module.exports = __webpack_public_path__ + "static/media/memberScanHistory.svg";